export const CONTENT_FILTERING_FIELDS = {
  showTraceabilityDetails: "showTraceabilityDetails",
  standardsToBeShown: "standardsToBeShown",
  logoFile: "logoFile",
  primaryProductAttributes: "primaryProductAttributes",
  secondaryProductAttributes: "secondaryProductAttributes",
  ecoScoreDataSource: "ecoScoreDataSource",
} as const

export const PRODUCT_ATTRIBUTES = {
  BRAND: "brand",
  NAME: "name",
  COLOR: "color",
  COLLECTION: "collection",
  BRAND_REFERENCE: "brandReference",
  PURCHASE_ORDER_REFERENCE: "purchaseOrderReference",
} as const

export type ProductAttribute =
  (typeof PRODUCT_ATTRIBUTES)[keyof typeof PRODUCT_ATTRIBUTES]

export type ContentFilteringField =
  (typeof CONTENT_FILTERING_FIELDS)[keyof typeof CONTENT_FILTERING_FIELDS]
